class RizonCookieConsent extends HTMLElement {
  connectedCallback() {
    this.banner = this.querySelector('[data-cookie-banner]');
    this.detailsModal = this.querySelector('.rizon-cookie-consent__details-modal');
    this.details = this.detailsModal.querySelector('details');
    this.manageSummary = this.detailsModal.querySelector('summary');
    this.saleOfDataRow = this.querySelector('[data-cookie-category="sale_of_data"]');
    this.checkboxes = {
      analytics: this.querySelector('[data-cookie-category="analytics"] input'),
      marketing: this.querySelector('[data-cookie-category="marketing"] input'),
      preferences: this.querySelector('[data-cookie-category="preferences"] input'),
      sale_of_data: this.querySelector('[data-cookie-category="sale_of_data"] input'),
    };

    this.querySelector('[data-cookie-accept]').addEventListener('click', () => this.acceptAll());
    this.querySelector('[data-cookie-decline]').addEventListener('click', () => this.declineAll());
    this.querySelector('[data-cookie-manage]').addEventListener('click', () => this.openPreferences());
    this.querySelector('[data-cookie-decline-all]').addEventListener('click', () => this.declineAll());
    this.querySelector('[data-cookie-save]').addEventListener('click', () => this.savePreferences());

    document.addEventListener('visitorConsentCollected', () => this.syncCheckboxes());

    this.init();
  }

  init() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify.customerPrivacy) return;
      this.api = window.Shopify.customerPrivacy;

      if (this.api.saleOfDataRegion && this.api.saleOfDataRegion()) {
        this.saleOfDataRow.hidden = false;
      }

      this.syncCheckboxes();

      // shouldShowBanner() reflects whether the visitor's region requires
      // a banner - per Shopify's own docs it "doesn't indicate if consent
      // has already been given" - so it can still read true after a
      // decision was already recorded. Defensively also require every
      // category to still be undecided ('') before actually showing it.
      const consent = this.api.currentVisitorConsent();
      const undecided = Object.keys(this.checkboxes).every((key) => consent[key] === '');
      if (this.api.shouldShowBanner() && undecided) this.showBanner();
    });
  }

  showBanner() {
    this.banner.hidden = false;
    requestAnimationFrame(() => this.banner.classList.add('is-visible'));
  }

  hideBanner() {
    this.banner.classList.remove('is-visible');
  }

  // Opens via the real <summary> click (not by setting the open
  // attribute directly) so Dawn's own DetailsModal.open() runs too -
  // that's what gives this dialog body-scroll-lock and focus trapping
  // for free, same as every other dialog in this theme. Deferred a tick:
  // this is itself called from the "Manage preferences" button's own
  // click handler, and DetailsModal.open() adds a body-level "click
  // outside closes it" listener - added synchronously, that listener
  // would still catch the tail end of *this same* click event as it
  // keeps bubbling toward body, seeing our button (outside the dialog)
  // as an outside click and closing what was just opened. Deferring
  // lets the original click finish bubbling first.
  openPreferences() {
    setTimeout(() => this.manageSummary.click());
  }

  closePreferences() {
    if (this.details.hasAttribute('open')) this.detailsModal.close();
  }

  // '' (undecided) and 'no' both read as unchecked - only an explicit
  // 'yes' shows as granted.
  syncCheckboxes() {
    if (!this.api) return;
    const consent = this.api.currentVisitorConsent();
    Object.keys(this.checkboxes).forEach((key) => {
      const checkbox = this.checkboxes[key];
      if (checkbox) checkbox.checked = consent[key] === 'yes';
    });
  }

  setConsent(consent) {
    if (!this.api) return;
    this.api.setTrackingConsent(consent, () => {
      this.hideBanner();
      this.closePreferences();
    });
  }

  acceptAll() {
    this.setConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
  }

  declineAll() {
    this.setConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
  }

  savePreferences() {
    const consent = {};
    Object.keys(this.checkboxes).forEach((key) => {
      const checkbox = this.checkboxes[key];
      if (checkbox) consent[key] = checkbox.checked;
    });
    this.setConsent(consent);
  }
}

if (!customElements.get('rizon-cookie-consent')) {
  customElements.define('rizon-cookie-consent', RizonCookieConsent);
}
